import { createStrings } from '@utils/local';

export const agencyStrings = createStrings({
  ja: {
    agency: '代理店',
    fcpNo: 'FCP番号',
    service: 'サービス',
    collectCities: '荷受け都市',
    d2dStaffNumber: 'D2Dスタッフ数',
    englishName: '英文名称',
    englishNameShort: '英文略称',
    japaneseName: '和文名称',
    japaneseNameShort: '和文略称',
    address1: '住所1',
    address2: '住所2',
    phone: 'TEL',
    fax: 'FAX',
    receivingWarehouse: '荷受倉庫',
    exportWarehouse: '輸出倉庫',
    receivingWarehouseDays: '荷受倉庫日数',
    exportWarehouseDays: '輸出倉庫日数',
    seaTransportDays: '海上運送日数',
    devanDays: 'デバン日数',
    errorNoAgency: '您当前不属于任何代理店，请与Admin联系！',
  },
});
